export const REASON_RULE_PHOTO_MANDATE = 'PHOTO_MANDATORY';
export const ORDER_STATUS = {
  delivered: 'delivered',
  cancelled: 'cancelled',
  rejected: 'rejected',
  pending: 'pending',
  approved: 'approved',
  reattempt: 'reattempt',
  dispatched: 'dispatched'
}

export const BROWSER_NAME = {
  CHROME: 'Chrome',
  FIREFOX: 'FIREFOX',
  SAFARI: 'SAFARI',
  VIVO: 'VIVO'
}

export const ASSET_PROTO = {
  assetName: "Select Asset Type",
  deliveredQuantity: "",
  recievedQuantity: ""
}

export const TRANSACTION_TYPE = {
  DEBIT: "debit",
  CREDIT: "credit"
}

export const STATUS_VALUE = {
  pending: 0,
  reattempt: 1,
  delivered: 2,
  cancelled: 3
}

export const SHORT_QUANTITY_UNITS = [
  { name: "Kgs", value: "kg" },
  { name: "Grams", value: "gram" },
  { name: "Count", value: "count" }
]

export const USER_TYPE = {
  DA: "da",
  ADMIN: "admin"
}

export const SUB_UOM = {
  piece: "Pieces",
  kg: "Kg",
  gm: "Gram",
  ltr: "Litre",
  ml: "Milliliter",
  bottle: "Bottle",
  crate: "Crate",
  dz: "Dozen",
  cm: "Cm",
  ft: "Foot",
  inch: "Inch",
  lb: "Pound",
  oz: "Ounce",
  m: "Meter"
}
